import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import ErrorBoundary from "./components/ErrorBoundary";

// Root-level boundary: catches catastrophic render errors anywhere in the tree
// and prevents a full white screen of death. The fallback prompts a page reload
// because the Redux store / router state is likely corrupted by this point.
const RootFallback = (
  <div style={{
    display:        'flex',
    flexDirection:  'column',
    alignItems:     'center',
    justifyContent: 'center',
    minHeight:      '100vh',
    fontFamily:     "'DM Sans', sans-serif",
    background:     '#0d0d0d',
    color:          '#888',
    textAlign:      'center',
    padding:        '40px',
  }}>
    <div style={{ fontSize: '28px', marginBottom: '12px', color: '#ca5f5f' }}>⚠</div>
    <div style={{ fontSize: '18px', fontWeight: 600, marginBottom: '8px', color: '#ccc' }}>
      Something went wrong
    </div>
    <div style={{ fontSize: '14px', marginBottom: '24px', maxWidth: '360px' }}>
      An unexpected error occurred. Reload the page to continue.
    </div>
    <button
      style={{
        padding: '10px 24px', borderRadius: '8px', border: 'none',
        background: '#A89FFF', color: '#0d0d0d', cursor: 'pointer',
        fontSize: '14px', fontWeight: 600,
      }}
      onClick={() => window.location.reload()}
    >
      Reload page
    </button>
  </div>
);

createRoot(document.getElementById("root") as HTMLElement).render(
    <React.StrictMode>
        <ErrorBoundary fallback={RootFallback}>
            <App />
        </ErrorBoundary>
    </React.StrictMode>
);
